// extracted by mini-css-extract-plugin
module.exports =  {"btnGroupRight":"ImeSWFlKjPllU5iReDiA","btnGroupLeft":"sHlf54wmo8AihE9qOcH9"};